import React from 'react'
import {
  Redirect,
  StandardLocalWidget,
  Updater,
  any,
  async,
  fromJSX,
  loadedAsyncState,
  loadingAsyncState,
  nothing,
} from 'widgets-for-react'
import { fieldUpdater } from '../../../Shared/Frontend/utils/fieldUpdater'
import { Loader } from '../../../Shared/Frontend/utils/loader'
import { submit } from './jotform.api'
import { JotformLayout } from './jotform.layout'
import { JotformState, Question } from './jotform.state'
import { hasErrors } from './jotform.utils'

export const jotformWidget =
  (id: string): StandardLocalWidget<JotformState> =>
  (state) => {
    const form = state.form
    const submitted = state.submitted
    return any([
      async(state.form).map(fieldUpdater<JotformState>()('form')),
      async(state.submitted).map(fieldUpdater<JotformState>()('submitted')),
      form.kind == 'loading'
        ? fromJSX(() => <Loader type="inline" />)
        : form.kind == 'loaded'
        ? fromJSX((setState) => (
            <>
              <JotformLayout
                questions={form.value.questions.map(
                  (question, index): Question & { setQuestion: (_: Updater<Question>) => void } => ({
                    ...question,
                    setQuestion: (updater) =>
                      setState((state) =>
                        state.form.kind == 'loaded'
                          ? {
                              ...state,
                              form: loadedAsyncState({
                                ...state.form.value,
                                questions: state.form.value.questions.map((q, i) => (i == index ? updater(q) : q)),
                              }),
                            }
                          : state
                      ),
                  })
                )}
                clickedSubmit={state.clickedSubmit}
                submitting={state.submitted.kind != 'unloaded'}
                submit={() => {
                  setState((state): JotformState => {
                    const form = state.form
                    const newState = { ...state, clickedSubmit: true }
                    return form.kind == 'loaded'
                      ? form.value.questions.some(hasErrors)
                        ? {
                            ...newState,
                            form: loadedAsyncState({
                              ...form.value,
                              questions: form.value.questions.map((question): Question => showErrors(question)),
                            }),
                          }
                        : { ...newState, submitted: loadingAsyncState(() => submit(id, form.value.questions)) }
                      : state
                  })
                }}
              />
              {submitted.kind == 'loaded' && <Redirect to={new URL(form.value.thankurl).pathname} />}
            </>
          ))
        : nothing(),
    ])
  }

const showErrors = (field: Question): Question => {
  if (field.kind == 'submitButton') return field
  else {
    const newField = { ...field, showErrors: true }
    switch (newField.kind) {
      case 'input':
      case 'textarea':
      case 'number':
      case 'select':
      case 'phone':
        return newField
      case 'email':
        return newField.extraConfirmationField
          ? { ...newField, extraConfirmationField: { ...newField.extraConfirmationField, showErrors: true } }
          : newField
      case 'fullName':
        return {
          ...newField,
          subFields: {
            ...newField.subFields,
            first: { ...newField.subFields.first, showErrors: true },
            last: { ...newField.subFields.last, showErrors: true },
          },
        }
      case 'radio':
        return newField.extraOption
          ? { ...newField, extraOption: { ...newField.extraOption, showErrors: true } }
          : newField
      case 'checkbox':
        return newField.extraOption
          ? { ...newField, extraOption: { ...newField.extraOption, showErrors: true } }
          : newField
    }
  }
}
